module.exports = __webpack_public_path__ + "media/images/icon__reddit@3x-d262a2bcb0cb351622e768afec1ebaec.png";